export default __webpack_public_path__ + "static/pwc-helvetica-neue-bold-500-e538f0d77fa8f5bd34534c0f9ab0bcc3.woff";